import { useEffect, useRef } from 'react';
import { Platform } from 'react-native';

// A keyboard lift may reveal the tail once it settles, but must never re-arm
// scrolling after the reader takes over or navigates to another conversation.
export default function useChatKeyboardScroll({
  keyboardHeight,
  conversationId,
  animatingRef,
  getScrollState,
  onPin,
}) {
  const previousHeightRef = useRef(keyboardHeight);
  const callbacksRef = useRef({ getScrollState, onPin });
  callbacksRef.current = { getScrollState, onPin };

  useEffect(() => {
    if (Platform.OS !== 'ios' && Platform.OS !== 'android') return undefined;
    const previousHeight = previousHeightRef.current;
    previousHeightRef.current = keyboardHeight;
    if (previousHeight === keyboardHeight) return undefined;

    animatingRef.current = true;
    const interaction = callbacksRef.current.getScrollState().interaction;
    const timer = setTimeout(() => {
      animatingRef.current = false;
      const state = callbacksRef.current.getScrollState();
      if (keyboardHeight > previousHeight && state.canPin && state.interaction === interaction) {
        callbacksRef.current.onPin({ followLive: state.followLive });
      }
    }, 350);
    return () => {
      clearTimeout(timer);
      animatingRef.current = false;
    };
  }, [keyboardHeight, conversationId, animatingRef]);
}
